import createConfigurableObject from '../../../utils/configurationObject';

import routes from './routes';
import tabs from './tabs';
import sideMenuItem from './sideMenu';
import interOfficeWavesTabs from './wavesTabs';

export default (app) => {
    app.interOfficeTabs = app.interOfficeTabs || createConfigurableObject();
    app.interOfficeTabs.addMany(tabs(app));

    app.interOfficeWavesTabs = app.interOfficeWavesTabs || createConfigurableObject();
    app.interOfficeWavesTabs.addMany(interOfficeWavesTabs(app));

    app.routes.addMany(routes(app));
    sideMenuItem(app);
};
